import React from "react";
import { useT } from "./i18n/context";
import { LegalPage } from "./i18n/LegalPage";

export function Privacy({ mobile = false }: { mobile?: boolean }) {
  const t = useT();
  const privacy = mobile ? t.mobilePrivacy : t.privacy;
  return <LegalPage title={privacy.title} subtitle={privacy.lastUpdated} sections={privacy.sections} />;
}
